import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import icons from 'src/icons';

import { Confirmation, useConfirmation } from '@alfalab/core-components/confirmation';

import { SystemMessageItem } from '../alert-message-modal/elems/system-message-item';

import { CustomHindComponent } from './custom-hind';
import { isNumber } from './is-number';

const declensionByNumbers = (number: number, titles: string[]) => {
    const cases = [2, 0, 1, 1, 1, 2];

    return `${number} ${
        titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]]
    }`;
};

export const OtpForm = () => {
    const [searchParams] = useSearchParams();
    const errorCode = searchParams.get('failure-reason'); // phone_blocked
    const source = searchParams.get('source') || '';
    const time = searchParams.get('time') || '';
    const blockDurationTime = parseInt(time, 10) * 60000;
    const [phoneNotFound, setPhoneNotFound] = useState(false);

    const message = source && isNumber(source) ? `+7 … … .. ${source}` : `${source}@alfabank.ru`;
    const {
        confirmationState,
        confirmationScreen,
        confirmationBlockSmsRetry,
        setConfirmationState,
        setConfirmationScreen,
    } = useConfirmation();

    const handleInputFinished = (code: string) => {
        setTimeout(() => {
            const form = document.createElement('form');

            form.method = 'post';
            form.action = '/my.policy';

            const hiddenField = document.createElement('input');

            hiddenField.type = 'hidden';
            hiddenField.name = 'password';
            hiddenField.value = code;

            form.appendChild(hiddenField);

            document.body.appendChild(form);
            form.submit();
        }, 1000);
    };

    const handleSmsRetryClick = () => {
        setTimeout(() => {
            setConfirmationState('INITIAL');
        }, 1000);
    };

    const handleTempBlockFinished = () => {
        window.location.href = '/';
    };

    const handleGoBackInitialScreen = () => {
        setConfirmationScreen('INITIAL');
    };

    useEffect(() => {
        switch (errorCode) {
            case 'error':
                setConfirmationState('CODE_ERROR');
                break;
            case 'fatal':
                setConfirmationScreen('FATAL_ERROR');
                break;
            case 'sms-requests-ended':
                setConfirmationState('CODE_ERROR');
                break;
            case 'phone_blocked':
                setConfirmationScreen('TEMP_BLOCK');
                break;
            case 'phone_not_found':
                setPhoneNotFound(true);
                break;
            default:
                break;
        }
    }, [errorCode, setConfirmationScreen, setConfirmationState]);

    if (phoneNotFound) {
        return (
            <div className='authForm'>
                <SystemMessageItem
                    title='Добавьте номер телефона, чтобы войти без VPN Банка'
                    subTitle='Это можно сделать в сервисе <strong>Личные данные</strong> Alfa People с включенным VPN Альфа-Банка'
                    icon={icons.AccountIcon}
                />
            </div>
        );
    }

    return (
        <div className='authForm'>
            <Confirmation
                screen={confirmationScreen}
                state={confirmationState}
                alignContent='center'
                blockSmsRetry={confirmationBlockSmsRetry}
                countdownDuration={60000}
                onChangeState={setConfirmationState}
                onChangeScreen={setConfirmationScreen}
                onInputFinished={handleInputFinished}
                onSmsRetryClick={handleSmsRetryClick}
                onTempBlockFinished={handleTempBlockFinished}
                tempBlockDuration={blockDurationTime}
                phone={message.length ? message : undefined}
                requiredCharAmount={4}
                hideCountdownSection={true}
                texts={{
                    title: 'Теперь код из сообщения',
                    countdown: '',
                    tempBlockDescription: `Повторное подтверждение кодом будет возможно через ${declensionByNumbers(
                        parseInt(time, 10),
                        ['минуту', 'минуты', 'минут'],
                    )}`,
                }}
                getScreensMap={(screensMap) => ({
                    ...screensMap,
                    HINT: () => CustomHindComponent({ source, action: handleGoBackInitialScreen }),
                })}
            />
        </div>
    );
};
